module.exports = __webpack_public_path__ + "img/Eastbourne-College-Weekends.086f37ce.jpg";